// Session state keeps several per-asset maps keyed by the *combined* asset
// index (predefined assets ++ customAssets, see selectAllAssets). Deleting a
// custom asset removes one slot, so every following asset shifts down by one
// and these maps must be re-keyed to match — otherwise the asset that moves
// into the freed slot inherits the deleted asset's data (SFX bed, video,
// blocks, …), which then renders into the wrong upload.

/** Shift a combined-index-keyed map down by one after the asset at
 *  `deletedIdx` is removed: keys below `deletedIdx` stay, `deletedIdx` itself
 *  is dropped, keys above collapse into the gap (`k` → `k - 1`). Pure —
 *  returns a new object, never mutates the input. */
export function shiftIndexMapAfterDelete<V>(
  obj: Record<number, V>,
  deletedIdx: number,
): Record<number, V> {
  const out: Record<number, V> = {};
  for (const [key, val] of Object.entries(obj)) {
    const k = Number(key);
    if (!Number.isFinite(k)) continue;
    if (k < deletedIdx) out[k] = val;
    else if (k > deletedIdx) out[k - 1] = val;
    // k === deletedIdx → drop
  }
  return out;
}
